import React from "react";
import type { Role } from "../models/auth";
import { ROLE_LABELS } from "../models/auth";

const COLORS: Record<Role, string> = {
  owner:
    "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-200",
  super_admin:
    "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-200",
  admin: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-200",
  evaluator:
    "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200",
  evaluatorTest:
    "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200",
  moderator:
    "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-200",
  instructor:
    "bg-fuchsia-100 text-fuchsia-800 dark:bg-fuchsia-900/30 dark:text-fuchsia-200",
  publisher: "bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-200",
  auditor:
    "bg-slate-200 text-slate-800 dark:bg-slate-900/30 dark:text-slate-200",
  user: "bg-neutral-200 text-neutral-800 dark:bg-neutral-900/30 dark:text-neutral-200",
};

export default function RoleBadge({
  role,
}: {
  role: Role | null;
}): React.ReactElement {
  const r: Role = role ?? "user";
  const label = ROLE_LABELS[r];
  return (
    <span className={`badge ${COLORS[r]}`} title={label}>
      {label}
    </span>
  );
}
